import { z } from "zod";

//* Define your environment variables schema here, so you get type safety throughout your app
export const EnvSchema = z.object({
	API_BASE_URL: z.url(), // API URL

	STORAGERESOURCENAME: z.string(), // Storage resource name
	STORAGESASTOKEN: z.string(), // Storage SAS token
	STORAGE_CONTAINER: z.string(), // Storage container

	HEADSHOTS_STORAGE_CONTAINER: z.string(), // Headshots storage container
	HEADSHOTS_STORAGESASTOKEN: z.string(), // Headshots storage SAS token
	HEADSHOTS_STORAGERESOURCENAME: z.string(), // Headshots storage resource name

	CONTENTIMAGES_STORAGE_CONTAINER: z.string(), // Content images storage container
	CONTENTIMAGES_STORAGESASTOKEN: z.string(), // Content images storage SAS token
	CONTENTIMAGES_STORAGERESOURCENAME: z.string(), // Content images storage resource name

	CLIENTS_API_BASE_URL: z.url().optional(), // Clients API base URL
	CLIENT_CODE: z.string().optional(), // Clients API code

	XTREME_API_URL: z.string(), // ExtremePush API URL
	XTREME_API_TOKEN: z.string(), // ExtremePush API token

	STORAGE_URL: z.url(), // Storage URL
});
